<template>
    <div id="loader" class="col-sm-2 mx-auto loader-spinner" :class="{ 'd-flex justify-content-center' : loading }">
        <Stretch background="#ec0000"></Stretch>
    </div>
</template>

<script>
    import { Stretch } from 'vue-loading-spinner'
    import { mapGetters } from 'vuex'

    export default {
        name: 'loader',
        props: ['data'],
        data() {
            return {
                loading: true,
            }
        },
        computed: {
            ...mapGetters([
               'getLoadingStatus'
            ]),
        },
        components: {
            Stretch
        },
        watch: {
            'getLoadingStatus': function(newVal) {
                this.loading = newVal;

                if(!newVal) {
                    this.$emit('onLoadingComplete', newVal);
                }
            }
        }
    }
</script>

<style>
    #loader {
        display: none;
    }
</style>